import React, { PureComponent, Fragment } from "react";
import Dinero from "dinero.js";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Grid } from "semantic-ui-react";

import { COST_FORMAT } from "../config.js";

import { secondsToString } from "../../utils/timeUtils.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UsageGrid extends PureComponent {
  static propTypes = {
    chargeData: PropTypes.object,
    usageData: PropTypes.object, // to become optional as chargeData is properly wired in
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "usage.usage_panel"
  };

  renderCharge() {
    const { chargeData, copyKey, copy } = this.props;
    if (!chargeData) return null;

    const price = Dinero({
      amount: chargeData.value,
      currency: chargeData.currency
    }).setLocale("en-GB");

    return (
      <Grid.Column>
        <strong>{copy(`${copyKey}.total_charge`)}</strong>
        <br />
        {` ${price.toFormat(COST_FORMAT)}`}
      </Grid.Column>
    );
  }

  renderUsage() {
    const { usageData, copyKey, copy } = this.props;
    if (!usageData) return null;

    return (
      <Grid.Column>
        <strong>{copy(`${copyKey}.total_usage`)}</strong>
        <br />
        {` ${secondsToString(usageData.value, copy("usage.time.abbr"))}`}
      </Grid.Column>
    );
  }

  render() {
    const { chargeData, usageData } = this.props;

    // bail early if base requirements are not met
    if (!chargeData && !usageData) {
      return null;
    }

    let columns = 0;
    if (chargeData) columns += 1;
    if (usageData) columns += 1;

    return (
      <Fragment>
        <Grid columns={columns}>
          {this.renderUsage()}
          {this.renderCharge()}
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UsageGrid);
